<template>
    <div class="disease-page">
        <div class="page-cont">
            <h2 class="page-tit">中医药知识图谱 · 疾病画像</h2>
            <div class="disease-search">
                <el-input
                    class="search-input"
                    v-model.trim="searchWord"
                    placeholder="请输入疾病名称"
                    clearable
                    @keyup.enter.native="search_click"
                ></el-input>
                <el-button type="primary" icon="el-icon-search" @click="search_click">检索</el-button>
            </div>
            <disease-result :search-word="searchWord" />
        </div>
    </div>
</template>

<script>
import DiseaseResult from './disease/comps/disease_result.vue';

export default {
    components: {
        DiseaseResult,
    },
    data() {
        return {
            searchWord: this.$route.query.word || '',
        };
    },
    methods: {
        search_click() {
            if (!this.searchWord) {
                this.$message.warning('请输入检索内容～');
                return;
            }
            const wordReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
            if (!wordReg.test(this.searchWord)) {
                this.$message.warning('请输入正确的检索词！');
                return;
            }
            this.$router.push({
                path: '/diseaseGraph',
                query: {
                    word: this.searchWord,
                    tab: 'doctor',
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.disease-page {
    min-height: 520px;
    background: #F5F9FF;
    padding: 20px 0 60px;
    min-width: 1200px;

    .page-tit {
        margin: 0 0 32px;
        font-size: 28px;
        font-weight: bold;
        color: #0C55AA;
        text-align: center;
    }

    .disease-search {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 28px;

        .search-input {
            width: 640px;
            margin-right: 16px;
        }

        ::v-deep .el-input__inner {
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            border-color: #C6DEFF;
        }

        .el-button {
            height: 44px;
            padding: 0 24px;
            background: #165DFF;
            border-color: #165DFF;
            border-radius: 8px;
        }
    }
}
</style>
